module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaAQMAAACThN6NAAAABlBMVEX///+ZmZmOUEqyAAAAFUlEQVQI12MgGvBgIf4fgBKYskQDAPxPA9/9eNEkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_add2.png
// module id = +3nJ
// module chunks = 9